import { useTranslation } from 'react-i18next';
import { ThicknessType } from '@steelbuy/ts-shared';
import { InputSelect } from '@steelbuy/ui-primitive';
import { getThicknessTypes } from '@steelbuy/util';

import { AnyValidationProps } from '../validation/Validation';
import { useRequiredFieldValidator } from '../validation/ValidationHooks';

type MaterialThicknessTypeSelectionProps = {
    thicknessType?: ThicknessType;
    thicknessTypeSelected: (thicknessType?: ThicknessType) => void;
} & AnyValidationProps;

export const MaterialThicknessTypeSelection = ({
    forceValidation,
    required,
    thicknessType,
    thicknessTypeSelected,
}: MaterialThicknessTypeSelectionProps) => {
    const { t } = useTranslation(['uiDomain', 'domainModel']);
    const requiredFieldValidator = useRequiredFieldValidator();

    const thicknessTypes = getThicknessTypes();

    const thicknessTypeOptions = thicknessTypes.map((type) => ({
        label: t(`domainModel:material.thicknessType.value.${type}`),
        value: type,
    }));

    return (
        <InputSelect
            options={thicknessTypeOptions}
            placeholder={t('uiDomain:materialSelection.placeholder')}
            value={thicknessType}
            onSelect={(value) => thicknessTypeSelected(value)}
            validators={required ? [requiredFieldValidator] : undefined}
            forceValidation={forceValidation}
            label={t('domainModel:material.thicknessType.name')}
        />
    );
};
